import { Token } from '@/domain/types/Token'
import { DialogPanel } from '@/features/dialogs/common/components/DialogPanel'
import { DialogPanelTitle } from '@/features/dialogs/common/components/DialogPanelTitle'
import { HealthFactorChange } from '../../common/components/transaction-overview/HealthFactorChange'
import { TokenValueChange } from '../../common/components/transaction-overview/TokenValueChange'
import { PositionOverview } from '../logic/types'
import { NumberValueChange } from '../../common/components/transaction-overview/NumberValueChange'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { getDisplayToken } from '@/domain/hooks/useDisplayToken'
import { useChainId } from 'wagmi'
export interface RepayOverviewPanelProps {
  debtAsset: Token
  collateralAsset?: Token
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  currentLiquidationPrice?: NormalizedUnitNumber
  updatedLiquidationPrice?: NormalizedUnitNumber
}
export function RepayOverviewPanel({
  debtAsset,
  collateralAsset,
  currentPositionOverview,
  updatedPositionOverview,
  currentLiquidationPrice,
  updatedLiquidationPrice,
}: RepayOverviewPanelProps) {
  const chainId = useChainId()
  const displayDebtAsset = getDisplayToken(chainId, debtAsset)
  const displayCollateralAsset = collateralAsset ? getDisplayToken(chainId, collateralAsset) : undefined
  return (
    <DialogPanel>
      <DialogPanelTitle>Transaction overview</DialogPanelTitle>
      <TokenValueChange
        token={displayDebtAsset}
        currentValue={currentPositionOverview.debt}
        updatedValue={updatedPositionOverview?.debt}
        label="Debt"
      />

      {displayCollateralAsset && (
        <TokenValueChange
          token={displayCollateralAsset}
          currentValue={currentPositionOverview.collateral}
          updatedValue={updatedPositionOverview?.collateral}
          label="Collateral"
        />
      )}

      {currentLiquidationPrice !== undefined && (
        <NumberValueChange
          currentValue={currentLiquidationPrice}
          updatedValue={updatedLiquidationPrice}
          label="Liquidation price"
        />
      )}
      <HealthFactorChange
        currentHealthFactor={currentPositionOverview.healthFactor}
        updatedHealthFactor={updatedPositionOverview?.healthFactor}
      />
    </DialogPanel>
  )
}
